import React from "reactn"
import { Link } from "gatsby"
import { useBreakpointValue } from "@chakra-ui/react"
import {
  Box,
  Button as ChakraButton,
} from '@chakra-ui/react';

export function Button({ button }) {
  const {
    text,
    color,
    style,
    link
  } = button && button[0] ? button[0] : {}

  
  var size 
  if (style == "large") {
    size = useBreakpointValue(['sm', 'md', 'lg', 'xl']) 
  } else if (style == "medium") {
    size = useBreakpointValue(['xs', 'sm', 'md', 'lg']) 
  } else {
    size = useBreakpointValue(['sm_s', 'sm_s', 'sm_s', 'sm_s']) 
  }
          
  return (
    <>
    { link && 
      <Link
        title={`Link to ${text}`}
        aria-label={`Link to ${text} page`}
        to={`/${link.slug.replace(/\/$/, '')}`}>
        <ChakraButton size={size} colorScheme={color} variant={`bottom_${style}`} >
          <Box as="h2" dangerouslySetInnerHTML={{__html: `<div> ${text} </div>`}}/>        
        </ChakraButton>
      </Link>
    }
    </>
  );
}

